import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function initialState () {
  return {
    token: null,
    user: null,
    ccInfo: null,
    nextPayment: null,
    referralProgram: null,
    planDetails: null,
    plusOneClients: {
      open_slots: 0,
      clients: []
    },
    addOns: null,
    showReferenceBooksDialog: false,
    referenceBookCart: [],
    billingHistory: null,
    emailNotifications: null,
    declinedPayment: null,
    isAppView: false,
    showManagePlanDialog: false,
    showUpdateCcDialog: false,
    showPayDialog: false,
    showConfirmPurchaseDialog: false,
    showCustomerSupportDialog: false,
    clients: null,
    showSuccessDialog: {
      active: false,
      message: null
    },
    initialUrlParameters: {},
    planToConfirm: {
      type: Object,
      default: () => ({
        product_code: '',
        name: '',
        price: 0,
        monthly: 0,
        details: {
          included: [],
          description: null,
        }
      })
    },
    showConfirmDialog: false
  }
}

export default new Vuex.Store({
  state: initialState,
  mutations: {
    reset (state) {
      // acquire initial state
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    setToken (state, token) {
      state.token = token;

      if (token != null) {
        // todo: change to secure when on https
        // window.$cookies.set('token', token, '1d', '/', window.location.hostname,true)
        if(process.env.VUE_APP_MODE === "production") {
          window.$cookies.set("token",token,null, "", "itovi.com");
        } else {
          window.$cookies.set('token', token)
        }
      } else {
          window.$cookies.remove('token', "", "itovi.com");
          window.$cookies.remove('token')
      }
    },
    setUser (state, user) {
      state.user = user
    },
    setIsAppView (state, isAppView) {
      state.isAppView = isAppView;
    },
    setEmailNotifications (state, emailNotifications) {
      state.emailNotifications = emailNotifications
    },
    setCcInfo (state, cc) {
      state.ccInfo = cc
    },
    setNextPayment (state, nextPayment) {
      state.nextPayment = nextPayment
    },
    setReferralProgram (state, referralProgram) {
      state.referralProgram = referralProgram
    },
    setPlanDetails (state, planDetails) {
      state.planDetails = planDetails
    },
    setPlusOneClients (state, plusOneClients) {
      state.plusOneClients = plusOneClients
    },
    setAddOns (state, addOns) {
      state.addOns = addOns
    },
    setShowReferenceBooksDialog (state, showReferenceBooksDialog) {
      state.showReferenceBooksDialog = showReferenceBooksDialog
    },
    setBillingHistory (state, billingHistory) {
      state.billingHistory = billingHistory
    },
    setClients (state, clients) {
      state.clients = clients
    },
    setDeclinedPayment (state, declinedPayment) {
      state.declinedPayment = declinedPayment
    },
    setShowSuccessDialog (state, showSuccessDialog) {
      state.showSuccessDialog = showSuccessDialog
    },
    setInitialUrlParameters (state, initialUrlParameters) {
      state.initialUrlParameters = initialUrlParameters
    },
    setShowManagePlanDialog (state, showManagePlanDialog) {
      state.showManagePlanDialog = showManagePlanDialog
    },
    setShowUpdateCcDialog (state, showUpdateCcDialog) {
      state.showUpdateCcDialog = showUpdateCcDialog
    },
    setShowPayDialog (state, showPayDialog) {
      state.showPayDialog = showPayDialog
    },
    setPlanToConfirm (state, planToConfirm) {
      state.planToConfirm = planToConfirm
    },
    setShowConfirmDialog (state, showConfirmDialog) {
      state.showConfirmDialog = showConfirmDialog
    },
    setShowConfirmPurchaseDialog (state, showConfirmPurchaseDialog) {
      state.showConfirmPurchaseDialog = showConfirmPurchaseDialog
    },
    setReferenceBookCart (state, referenceBookCart) {
      state.referenceBookCart = referenceBookCart
    },
    setShowCustomerSupportDialog (state, showCustomerSupportDialog) {
      state.showCustomerSupportDialog = showCustomerSupportDialog
    }
  },
  actions: {

  },
})
